import { compose, lifecycle, withStateHandlers, withHandlers } from 'recompose'
import { withCookies } from 'react-cookie'
import { withRouter } from 'react-router'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { checkAuth, logout } from '../api/index'
import { initSession } from '../store/effects/auth'
import { authChecked } from '../store/actions/auth'

export const withLogout = compose(
  withCookies,
  withHandlers({
    logout: ({ cookies }) => () => {
      cookies.remove('CookunityAwesomeCookie')
      logout().then(() => {
        window.location = `${process.env.REACT_APP_SITE_BASE_URL}/groupedajax/ajax/landing_logout/`
      })
    }
  })
)

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      initSession,
      authChecked
    },
    dispatch
  )

export const withAuthContainer = compose(
  withRouter,
  withCookies,
  connect(null, mapDispatchToProps),
  withStateHandlers(
    ({ cookies, history }) => {
      const data = cookies.get('CookunityAwesomeCookie')
      if (data && data.id && history.location.pathname === '/login') {
        return history.push('/')
      }

      // We return authed true since we are going to check with checkout the session
      return { authed: true, cookieListener: null }
    },
    {
      setAuth: ({ authed, ...rest }) => value => ({ ...rest, authed: value }),
      setListener: state => listener => ({
        ...state,
        cookieListener: listener ? listener : null
      })
    }
  ),
  lifecycle({
    componentWillMount() {
      const {
        cookies,
        initSession,
        setAuth,
        setListener,
        authChecked
      } = this.props
      setListener(
        cookies.addChangeListener(cookie => {
          if (cookie.name === 'CookunityAwesomeCookie' && !!cookie.value) {
            const { id } = JSON.parse(cookie.value)
            initSession(id)
            return setAuth(true)
          }
          setAuth(false)
        })
      )
      checkAuth()
        .then(response => {
          cookies.set('CookunityAwesomeCookie', response.data, {
            path: '/',
            expires: new Date(Date.now() + process.env.REACT_APP_AUTH_EXP_TOKEN)
          })
          if (response.data && response.data.email && window.analytics) {
            window.analytics.identify(
              response.data.id,
              {
                email: response.data.email
              },
              {
                Intercom: { hideDefaultLauncher: true }
              }
            )
          }
          authChecked()
          setAuth(true)
        })
        .catch(err => {
          if (err && err.response && err.response.status === 401) {
            cookies.remove('CookunityAwesomeCookie')
          }
          authChecked()
          setAuth(false)
        })

      return setAuth(true)
    },
    componentWillUnmount() {
      const { cookies, cookieListener, setListener } = this.props
      cookies.removeChangeListener(cookieListener)
      setListener(null)
    }
  })
)



// WEBPACK FOOTER //
// ./src/hocs/withAuthContianer.js